import { IS_US } from '@/utils/constants';

// Hide the US Terms Update entry after September 14, 2026 (New York, EDT).
const TERMS_UPDATE_HIDE_AT = Date.parse('2026-09-15T00:00:00-04:00');

export function shouldShowTermsUpdate(serverTimestamp: unknown): boolean {
  if (!IS_US) return false;

  const timestamp =
    typeof serverTimestamp === 'number'
      ? serverTimestamp
      : typeof serverTimestamp === 'string'
        ? Number(serverTimestamp)
        : Number.NaN;

  if (!Number.isFinite(timestamp) || timestamp <= 0) return false;

  const timestampInMilliseconds = timestamp < 1_000_000_000_000 ? timestamp * 1000 : timestamp;
  return timestampInMilliseconds < TERMS_UPDATE_HIDE_AT;
}
